export const PLAYBACK_PAGE = 'Video Playback Page';
export const HOME_PAGE = 'Video Home Page';
export const LANDING_PAGE = 'Video Landing Page';
export const SEARCH_PAGE = 'Multimedia Search';
export const PLAYBACK_HEADER = 'Video Playback Header';
export const REELS_PAGE = 'My Reels';
export const VIDEO_SECTION = 'Video Section';
export const APP_RUNTIME_ERROR = 'App Runtime Error';